import Route from '@ember/routing/route';

import type { CoachingCoacheeCohortCoachesCoachModel } from '../coach';

export default class CoachingCoacheeCohortCoachesCoachChemistryRoute extends Route<CoachingCoacheeCohortCoachesCoachModel> {
  model(): CoachingCoacheeCohortCoachesCoachModel {
    return this.modelFor(
      'coaching.coachee.cohort.coaches.coach'
    ) as CoachingCoacheeCohortCoachesCoachModel;
  }
}
